export function dateTimeFormat(UNIX_timestamp: any): any {

  const monthNumber = (num: number) => {
    return num < 10 ? '0' + num : num
  }

  if(UNIX_timestamp == 0) return ''
  const a = String(UNIX_timestamp).length === 10 ? new Date(UNIX_timestamp * 1000) : new Date(UNIX_timestamp)
  const year = a.getFullYear();
  const month = monthNumber(a.getMonth() + 1)
  const date = monthNumber(a.getDate())
  const clock = monthNumber(a.getHours())
  const min = monthNumber(a.getMinutes())
  const rTime = clock + ':' + min
  const rDate = date + '.' + month + '.' + year

  return {rDate, rTime};
}
